import * as React from 'react';
import { connect } from 'react-redux';

import { userInfoData$ } from '../../selectors/findUser';

import UserCard from '../UserCard/UserCard';
import Form from '../Form/Form';

import State from '../../interfaces/states/State';
import UserInfo from '../../interfaces/UserInfo';

import './style.scss';

interface Props {
  userInfo: UserInfo[];
}

const FirstPageForm = (props: Props) => {
  return(
    <div className='d-flex justify-center align-center first-page-container'>
      {
        props.userInfo
          ? <UserCard />
          : <Form />
      }
    </div>
  );
};

const mapStateToProps = (state: State) => {
  return {
    userInfo: userInfoData$(state),
  };
};

export default connect(
  mapStateToProps
)(FirstPageForm);
